import type { PropsWithChildren } from "react";

import { UIView } from "@uirouter/react";

import { Flex } from "@similarweb/ui-components/foundations";

import { DefaultErrorBoundary } from "app/components/error-boundary-no-data/DefaultErrorBoundry";

import { EmptyCampaignState, ErrorCampaignState, PageLoadingState } from "../../shared/components/page-states";
import { MonitorAndProtectTrademarkSubNav } from "../../shared/trademark-sub-navigation";
import { Content } from "../../shared/ui/layout/content";
import { NavContainer } from "../../shared/ui/layout/navigation-container";

const ContentSwitcher = ({ children }: PropsWithChildren) => {
    const loading = false;
    const isError = false;
    const data = [];

    if (loading) {
        return <PageLoadingState />;
    }

    if (isError) {
        return <ErrorCampaignState />;
    }

    if (!data) {
        return <EmptyCampaignState flex="1" />;
    }

    return children;
};

export const MonitorAndProtectTrademarkRoot = () => {
    return (
        <Flex
            height="100vh"
            flexDirection="column"
        >
            <NavContainer>
                <MonitorAndProtectTrademarkSubNav />
            </NavContainer>
            <Content>
                <ContentSwitcher>
                    <DefaultErrorBoundary>
                        <UIView className="fadeIn" />
                    </DefaultErrorBoundary>
                </ContentSwitcher>
            </Content>
        </Flex>
    );
};
